export default __webpack_public_path__ + "static/media/DosimetristOn.c676265e.svg";